var _path, _rect, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3609 2.83097C11.2353 1.85416 12.7647 1.85416 13.6391 2.83097L14.41 3.69202C14.8556 4.18984 15.5034 4.45815 16.1705 4.42127L17.3244 4.35748C18.6335 4.28511 19.7149 5.36651 19.6425 6.67556L19.5787 7.82947C19.5418 8.49662 19.8102 9.14437 20.308 9.59004L21.169 10.3609C22.1458 11.2353 22.1458 12.7647 21.169 13.6391L20.308 14.41C19.8102 14.8556 19.5418 15.5034 19.5787 16.1705L19.6425 17.3244C19.7149 18.6335 18.6335 19.7149 17.3244 19.6425L16.1705 19.5787C15.5034 19.5418 14.8556 19.8102 14.41 20.308L13.6391 21.169C12.7647 22.1458 11.2353 22.1458 10.3609 21.169L9.59004 20.308C9.14437 19.8102 8.49662 19.5418 7.82947 19.5787L6.67556 19.6425C5.36651 19.7149 4.28511 18.6335 4.35748 17.3244L4.42127 16.1705C4.45815 15.5034 4.18984 14.8556 3.69202 14.41L2.83097 13.6391C1.85416 12.7647 1.85416 11.2353 2.83097 10.3609L3.69202 9.59004C4.18984 9.14437 4.45815 8.49662 4.42127 7.82947L4.35748 6.67556C4.28511 5.36651 5.36651 4.28511 6.67556 4.35748L7.82947 4.42127C8.49662 4.45815 9.14437 4.18984 9.59004 3.69202L10.3609 2.83097Z",
    fill: "#FFAA00",
    stroke: "#FFAA00"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.25,
    y: 9.25,
    width: 0.011,
    height: 0.011,
    stroke: "white",
    strokeWidth: 2.75,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.75,
    y: 14.75,
    width: 0.011,
    height: 0.011,
    stroke: "white",
    strokeWidth: 2.75,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3 8.7L8.69995 15.3",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRate);
export default __webpack_public_path__ + "static/media/rate.20a3c2a813196ca39861338e714df047.svg";
export { ForwardRef as ReactComponent };